import { InfoIcon } from './icons/icons-new'

export function WarningInfo({ hasWarning }: { hasWarning: boolean }) {
  return (
    hasWarning && (
      <div className="absolute -top-2 right-0 flex h-5 w-5 items-center justify-center rounded-full bg-amber-400">
        <InfoIcon width={12} height={12} color="black" />
      </div>
    )
  )
}
